import {getSessionGeneration} from './sessionGeneration.js'
import {MOVE_STAGES, moveOutcome, moveFailure} from './pursuitMove.js'

export function createPursuitMoveController({send, onLanded = () => {}, session = getSessionGeneration, makeRequestId = () => globalThis.crypto?.randomUUID?.()}) {
  const generation = session(), pending = new Set(), uncertain = new Set()
  let active = true
  const current = () => active && generation === session()
  return {
    dispose() { active = false },
    async move(record, to) {
      const id = String(record?.id ?? '')
      if (!current()) return {landed: false, stale: true}
      if (!id || !MOVE_STAGES.some(stage => stage.key === to)) return {landed: false, reason: 'Choose a valid record and pursuit stage.'}
      if (pending.has(id)) return {landed: false, reason: 'This record already has a move pending.'}
      if (uncertain.has(id)) return {landed: false, uncertain: true, reason: 'Refresh this record and inspect move history before another attempt.'}
      const requestId = makeRequestId()
      if (typeof requestId !== 'string' || !requestId) return {landed:false,reason:'A unique move identity could not be created. Nothing was sent.'}
      pending.add(id)
      try {
        const res = await send(record, to, requestId)
        if (!current()) return {landed: false, stale: true}
        const result = moveOutcome(res, to, id)
        if (result.landed && res.requestId === requestId) onLanded(record.id, to)
        else {
          uncertain.add(id)
          return {landed: false, uncertain: true, reason: 'The server returned no matching target and status receipt. Refresh the record and inspect its move history before another attempt.'}
        }
        return result
      } catch (error) {
        if (!current()) return {landed: false, stale: true}
        const knownRefusal = [400, 401, 403, 404, 409, 422, 423].includes(error?.status) && error?.body?.retrySafe !== false && error?.body?.uncertain !== true
        if (!knownRefusal) uncertain.add(id)
        return {landed: false, uncertain: !knownRefusal, reason: moveFailure(error)}
      } finally { pending.delete(id) }
    },
  }
}
